import { Box, Typography, CardContent, Card, Grid } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';

const AdminDetails = () => {
  const location = useLocation();
  const { admin } = location.state || {};

  if (!admin)
    return (
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box sx={{ padding: 4 }}>
            <Typography>No admin selected</Typography>
          </Box>
        </CardContent>
      </Card>
    );

  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <Typography variant="h5" gutterBottom>
              Admin:{admin.name}
            </Typography>
          </Box>
        </CardContent>
      </Card>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 'bold', paddingLeft: 4 }}>
            Personal Details
          </Typography>
          <Box sx={{ padding: 4 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  First Name:
                </Typography>
                <Typography variant="body1">
                  {admin.name.split(' ')[0]}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Last Name:
                </Typography>
                <Typography variant="body1">
                  {admin.name.split(' ').slice(-1)}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Email Address:
                </Typography>
                <Typography variant="body1">{admin.email}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Role:
                </Typography>
                <Typography variant="body1">
                  {admin.roleId === 1
                    ? 'Admin'
                    : admin.roleId === 2
                      ? 'User'
                      : 'N/A'}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                  Status:
                </Typography>
                <Typography variant="body1">
                  {admin.isActive ? 'Active' : 'Inactive'}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
  );
};

export default AdminDetails;
